<style>
.lbl-title {
  color: red;
  font-weight: bold;
  font-size: 20px;
}
.btn-importe {
  border: 2px solid red;
  background-color: white;
  color: red;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mis Cuentas</b-card-header>

      <b-card-body v-if="MostrarMensajeResuesta">
        <div class="row">
          <div class="col-md-12 text-center">
            <base-alert :type="resultadoRespuesta.Tipo">
              <span class="alert-inner--icon" style="font-size: 60px;">
                <i :class="resultadoRespuesta.Icono"></i>
              </span>
              <br />
              <span class="alert-inner--text" v-html="resultadoRespuesta.Texto"></span>
              <br />
              <span
                class="alert-inner--text"
                v-html="resultadoRespuesta.TextoSecundario"
                style="font-size: 13px;"
              ></span>
            </base-alert>
          </div>
        </div>
        <div class="row" style="margin-top: 30px">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="goBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
        </div>
      </b-card-body>
      <b-card-body v-else>
        <div class="col-md-12 text-center lbl-title">¿Cuánto dinero querés ingresar?</div>
        <div
          class="col-md-12 text-center"
          style="padding-bottom:30px;font-size:13px"
        >El importe se debitará de la cuenta elegida</div>
        <div class="col-md-12 text-center">
          <img src="/img/icons/android-icon-144x144.png" />
        </div>
        <div
          class="col-md-12 text-center"
          style="padding-bottom:30px;font-size:13px"
        >Ingresá un importe</div>
        <div class="row form-group" style="justify-content: center;">
          <div class="col-md-3">
            <vue-numeric
              currency="$"
              v-bind:precision="2"
              decimal-separator="."
              thousand-separator=" "
              v-model="Amount"
              class="form-control"
              style="text-align:center"
            ></vue-numeric>
          </div>
        </div>
        <div class="col-md-12 text-center" style="margin-top: 20px">
          <b-button
            class="btn btn-success"
            @click="ConfirmAddMoney()"
            :disabled="Amount<=0"
          >Ingresar Dinero</b-button>
        </div>
        <hr />
        <div
          class="col-md-12 text-center"
          style="padding-bottom:30px;font-size:13px"
        >Seleccioná un importe</div>
        <div class="row form-group" style="justify-content: center;">
          <div class="text-center" style="width:110px">
            <b-button class="btn btn-importe" @click="SetAmount(5000)">$ 5.000</b-button>
          </div>
          <div class="text-center" style="width:110px">
            <b-button class="btn btn-importe" @click="SetAmount(10000)">$ 10.000</b-button>
          </div>
          <div class="text-center" style="width:110px">
            <b-button class="btn btn-importe" @click="SetAmount(25000)">$ 25.000</b-button>
          </div>
          <div class="text-center" style="width:110px">
            <b-button class="btn btn-importe" @click="SetAmount(50000)">$ 50.000</b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import confirmHelpers from "@/helpers/confirmHelpers";
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  props: {
    AccountPSPIDProp: Number
  },
  data() {
    return {
      AccountPSPID: this.AccountPSPIDProp,
      Amount: 0,
      MostrarMensajeResuesta: false,
      resultadoRespuesta: {
        Texto: "",
        TextoSecundario: "",
        Tipo: "",
        Icono: ""
      }
    };
  },
  methods: {
    SetAmount(amount) {
      let context = this;
      this.Amount = amount;
    },
    ConfirmAddMoney() {
      let context = this;

      confirmHelpers.showConfirm(
        "¿Querés ingresar $" + context.Amount + " a tu cuenta?",
        context,
        function() {
          context.AddMoney();
        }
      );
    },
    AddMoney() {
      let context = this;
      axiosHelpers.axiosPostWithoutAlerts(
        "RecruitmentAccountsPsp/MakePullTransfer",
        {
          RecruitmentAccountPspID: context.AccountPSPID,
          Amount: context.Amount
        },
        context,
        function(data) {
          context.MostrarMensajeResuesta = true;
          if (data.ResponseVM.Success && data.ResponseVM.IsPending == false) {
            context.resultadoRespuesta = {
              Texto: "Transacción realizada con éxito!",
              TextoSecundario: "El dinero ingresó correctamente",
              Tipo: "success",
              Icono: "fa fa-fw fa-check-circle"
            };
          } else if (data.ResponseVM.IsPending) {
            context.resultadoRespuesta = {
              Texto: "Operación pendiente!",
              TextoSecundario: data.Alerts[0].Message,
              Tipo: "warning",
              Icono: "fa fa-fw fa-exclamation-circle"
            };
          } else {
            if (data.Alerts.length > 0) {
              context.resultadoRespuesta = {
                Texto: data.Alerts[0].Message,
                Tipo: "danger",
                Icono: "fa fa-fw fa-times-circle"
              };
            }
          }
        }
      );
    },
    goBack() {
      this.$router.push("miscuentas");
    }
  },
  computed: {},
  beforeMount: function() {}
};
</script>